import { getLocaleDecimalSeparator } from '#helper';

export const outputFormatOptions = {
  PDF: 'pdf',
  CSV: 'csv'
};

const buildPDFReportPath = ({
  deviceId,
  startDate,
  endDate,
  measurementSystem,
  selectedContentOptions
}) => {
  const contentOptionToQueryParameter = {
    locations: 'includeLocations',
    statisticalSummary: 'includeStatistics',
    measurementsTable: 'includeMetrics',
    temperatureChart: 'temperature',
    humidityChart: 'humidity'
  };

  const chartsOptions = {
    temperatureChart: 'temperature',
    humidityChart: 'humidity'
  };

  const query = new URLSearchParams({
    measurementSystem
  });

  const chartsParams = [];

  Object.entries(contentOptionToQueryParameter).forEach(([option, parameter]) => {
    if (selectedContentOptions[option]) {
      if (chartsOptions[option]) {
        chartsParams.push(parameter);
      } else {
        query.set(parameter, true);
      }
    }
  });

  if (chartsParams.length) {
    query.set('includeCharts', chartsParams);
  }

  return `report-external/device/${deviceId}/${startDate}/${endDate}?${query.toString()}`;
};

const buildCSVReportPath = ({
  deviceId,
  startDate,
  endDate,
  measurementSystem
}) => {
  const query = new URLSearchParams({
    system: measurementSystem
  });

  const decimalSeparator = getLocaleDecimalSeparator();

  if (decimalSeparator === ',') {
    query.set('decimalSeparator', 'comma');
  }

  return `report/csv/device/${deviceId}/${startDate}/${endDate}/?${query.toString()}`;
};

const buildReportPath = ({
  outputFormat,
  deviceId,
  startDate,
  measurementSystem,
  endDate,
  contentOptions
}) => {
  const selectedContentOptions = Object.fromEntries(
    contentOptions.map(({ name, checked }) => [name, checked])
  );

  if (outputFormat === outputFormatOptions.CSV) {
    return buildCSVReportPath({
      deviceId,
      startDate,
      endDate,
      measurementSystem
    });
  }

  return buildPDFReportPath({
    deviceId,
    startDate,
    endDate,
    measurementSystem,
    selectedContentOptions
  });
};

export default buildReportPath;
